module.exports = __webpack_public_path__ + "static/media/Instructions.3df7d9fc.png";